import {
    Button,
    CircularProgress,
    Grid,
    IconButton,
    makeStyles,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
    withStyles
} from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import DialogComp from '../../../../Core/Controls/Dialog/DialogComp';
import moment from 'moment';
import React, { useCallback, useContext, useEffect, useState } from 'react';
import { getTcardBranchData, getTcardData, getTCardWipData, postTCardsDragStatus } from '../../../../Core/Service/TCardDashboard-service';

import TCardDashboardModal from '../Dashboard/T-cardModal';
import TCardsCloseDay from '../Dashboard/TCardsCloseDay';

import { useHistory } from 'react-router-dom';
import { AppStorage } from '../../../../Core/Service/storage-service';
import { getTCards_ScreenDropdown } from '../../../../Core/Service/checkInRole';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import AppContext from '../../../../App/AppContext';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import { Tcard } from '../Dashboard/TcardTemplates/mainTcard';

const marginBottom = { marginBottom: 8 };

const useStyles = makeStyles({
    table: {
        minWidth: '1280px',
        width: '99.7%',
        paddingBottom: 100
    },
    colHeight: {
        overflowY: 'auto',
        verticalAlign: 'baseline'
    },
    Tcard: {
        cursor: 'pointer',
        padding: 3,
        border: '1.5px solid rgba(0,0,0,0.1)',
        position: 'relative',
        '&:hover': {
            border: '1px solid rgba(0,0,0,0.9)',
            '& $editButton': {
                opacity: 50 // Show the button on hover
            }
        }
    },
    editButton: {
        position: 'absolute',
        top: 5,
        right: 5,
        opacity: 0,
        transition: 'opacity 0.3s ease-in-out',
        background: 'white'
    },
    draggingOver: {
        backgroundColor: 'rgba(0, 0, 0, 0.12) !important'
    },
    noRecordFound: {
        height: '46px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '11px',
        border: '1px dotted rgba(0, 0, 0, 0.05)'
    }
});

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: '#283242',
        color: theme.palette.common.white,
        padding: '5px '
    },
    body: {
        fontSize: 14,
        padding: '10px 5px 10px 5px ',
        border: 'none',
        verticalAlign: 'baseline'
    }
}))(TableCell);

const HeadingTableCell = withStyles((theme) => ({
    head: {
        padding: '0px 5px',
        border: '1px solid rgba(0,0,0,0.04)'
    },
    body: {
        padding: '0px 5px',
        border: 'none',
        fontWeight: 600,
        verticalAlign: 'baseline'
    }
}))(TableCell);

// const Tcard = ({ customer, registration, color, isLoanVehicle, status, date, tCardsID, handleTcardOpen, textColor, legendItems }) => {
//     const portalSetting = AppStorage.getPortalSetting();
//     const classes = useStyles();
//     const [hovered, setHovered] = useState(false);

//     return (
//         <div
//             style={{ background: color }}
//             className={classes.Tcard}
//             onMouseEnter={() => setHovered(true)}
//             onMouseLeave={() => setHovered(false)}
//             onClick={() => handleTcardOpen(true, tCardsID, false, color)}
//         >
//             <Grid container justifyContent="space-between">
//                 <Grid item style={{ display: 'flex' }}>
//                     <Typography style={{ fontSize: 11, fontWeight: 600, textAlign: 'left', color: textColor }}>{registration} </Typography> &nbsp;
//                     {isLoanVehicle && (
//                         <div
//                             style={{
//                                 fontSize: 6,
//                                 fontWeight: 600,
//                                 background: portalSetting.portalSettingsLoanVehicleBgColor,
//                                 color: portalSetting.portalSettingsLoanVehicleTextColor,
//                                 padding: '2px 4px',
//                                 height: 10
//                             }}
//                         >
//                             {portalSetting.portalSettingsLoanVehicleText}
//                         </div>
//                     )}
//                 </Grid>

//                 <Grid item>
//                     <Typography style={{ fontSize: 9, fontWeight: 600, textAlign: 'right', color: textColor }}>{customer}</Typography>
//                 </Grid>
//             </Grid>
//             <Grid container justifyContent="space-between" alignItems="center">
//                 <Grid item xs={2}>
//                     <Typography style={{ fontSize: 10, fontWeight: 600, textAlign: 'left', color: textColor }}>
//                         {date ? moment(date).format('DD/MM') : 'N/A'}
//                     </Typography>
//                 </Grid>
//                 <Grid item xs={10}>
//                     {/* {status && ( */}
//                     <div style={{ display: 'grid', rowGap: 1, gridTemplateColumns: 'repeat(9, 1fr)', justifyContent: 'flex-end' }}>
//                         {legendItems?.map((k) => {
//                             if (status[k.st]) {
//                                 return (
//                                     <div key={k.st} style={{ margin: '0px 2px' }}>
//                                         <Typography
//                                             style={{
//                                                 fontSize: 8,
//                                                 fontWeight: 600,
//                                                 background: k.background,
//                                                 color: k.color ? k.color : 'white',
//                                                 padding: 2
//                                             }}
//                                         >
//                                             {k.label}
//                                         </Typography>
//                                     </div>
//                                 );
//                             } else {
//                                 return (
//                                     <div key={k.st} style={{ margin: '0px 2px' }}>
//                                         <Typography
//                                             style={{
//                                                 fontSize: 6,
//                                                 fontWeight: 600,
//                                                 // background: k.background,
//                                                 color: 'white',
//                                                 padding: 2
//                                             }}
//                                         ></Typography>
//                                     </div>
//                                 );
//                             }
//                         })}
//                     </div>
//                     {/* )} */}
//                 </Grid>
//                 {status.motloc && (
//                     <Grid item xs={12}>
//                         <Typography style={{ fontSize: 9, fontWeight: 600, textAlign: 'left', color: textColor }}>
//                             {status.motloc} ({moment(status.motdate).format('DD-MM-YYYY HH:MM')})
//                         </Typography>
//                     </Grid>
//                 )}
//             </Grid>
//         </div>
//     );
// };

const InProgress = () => {
    const curretDate = moment();
    const portalSetting = AppStorage.getPortalSetting();
    const classes = useStyles();
    const statusObject = AppStorage.getTCardStatus();

    const history = useHistory();

    const legendItems = [
        {
            label: portalSetting.portalSettingsCollectionDeliverText,
            background: portalSetting.portalSettingsCollectionDeliverBgColor || 'black',
            color: portalSetting.portalSettingsCollectionDeliverTextColor || 'white',
            st: 'cd'
        },
        {
            label: portalSetting.portalSettingsCustomerWaitingText,
            background: portalSetting.portalSettingsCustomerWaitingBgColor || 'black',
            color: portalSetting.portalSettingsCustomerWaitingTextColor || 'white',
            st: 'waiting'
        },
        {
            label: portalSetting.portalSettingsServiceText,
            background: portalSetting.portalSettingsServiceBgColor || 'black',
            color: portalSetting.portalSettingsServiceTextColor || 'white',
            st: 'service'
        },
        {
            label: portalSetting.portalSettingsInspectionText,
            background: portalSetting.portalSettingsInspectionBgColor || 'black',
            color: portalSetting.portalSettingsInspectionTextColor || 'white',
            st: 'inspection'
        },
        {
            label: portalSetting.portalSettingsMOTText,
            background: portalSetting.portalSettingsMOTBgColor || 'black',
            color: portalSetting.portalSettingsMOTTextColor || 'white',
            st: 'mot'
        },
        {
            label: portalSetting.portalSettingsRepairText,
            background: portalSetting.portalSettingsRepairBgColor || 'black',
            color: portalSetting.portalSettingsRepairTextColor || 'white',
            st: 'repair'
        },
        {
            label: portalSetting.portalSettingsNightShiftText,
            background: portalSetting.portalSettingsNightShiftBgColor || 'black',
            color: portalSetting.portalSettingsNightShiftTextColor || 'white',
            st: 'ns'
        },
        {
            label: portalSetting.portalSettingsRecallJobText,
            background: portalSetting.portalSettingsRecallJobBgColor || 'black',
            color: portalSetting.portalSettingsRecallJobTextColor || 'white',
            st: 'recall'
        },

        {
            label: portalSetting.portalSettingsTachoText,
            background: portalSetting.portalSettingsTachoBgColor || 'black',
            color: portalSetting.portalSettingsTachoTextColor || 'white',
            st: 'tacho'
        }
    ];

    const { hideModal, showToast } = useContext(AppContext);

    const [tCardList, setTCardList] = useState({
        bookingConfirmed: [],
        startDate: moment(),
        waitingStart: [],
        noShow: [],
        motPrep: [],
        inProg: [],
        awaitingCallBack: [],
        partOrder: [],
        recall: [],
        branchID: '',
        toSchedule: [],
        tCardID: null,
        tCardSelectedColor: '',
        tCardStatus: [],
        allocatedHours: [],
        usersHoliday: [],
        tpNames: [],
        showLoader: true
    });

    const [Start, setStart] = useState('');
    const [openModal, setOpenModal] = useState(false);
    // const [closeDayModal, setCloseDayModal] = useState(false);
    const [End, setEnd] = useState('');
    const [branchList, setBranchList] = useState([]);
    // const [selectedDate, setSelectedDate] = useState(null);
    const [status, setStatus] = useState([]);
    const [loader, setLoader] = useState(true);

    const [expand, setExpand] = useState({});

    const [filters, setFilters] = useState({
        regNo: '',
        cust: ''
    });

    const [filterTcard, setFilterTcard] = useState({});

    let statusSeq = [9, 7, 2, 11, 3, 6, 5];
    let statusSeq2 = [0, 8];

    const handleTcardOpen = (cond, id, res, color) => {
        setOpenModal(cond);
        setTCardList((state) => ({
            ...state,
            tCardID: id,
            tCardSelectedColor: color
        }));

        res && fetchData();
    };

    const fetchData = useCallback(async () => {
        if (tCardList.branchID) {
            setLoader(true);
            let res = await getTCardWipData(tCardList.branchID);
            if (res.success) {
                let data = res.data.tCards;
                let tpNames = new Set(data.map((k) => k.tp));
                setFilterTcard((st) => ({
                    ...st,
                    tCardStatus: data || [],
                    recall: data.filter((k) => k.status === 'RECALL'),
                    tpNames: Array.from(tpNames)
                }));

                setTCardList((st) => ({
                    ...st,
                    tCardStatus: data || [],
                    recall: data.filter((k) => k.status === 'RECALL'),
                    tpNames: Array.from(tpNames)
                }));

                setLoader(false);
            }
        }
    }, [tCardList.branchID, Start, End]);

    useEffect(() => {
        let fetchData = async () => {
            let res = await getTCards_ScreenDropdown();
            if (res.success) {
                setStatus(res.data.tCardsStatus.filter((m) => m.name !== 'BOOKING CONFIRMED' && m.name !== 'COLLECTED') || []);
            } else {
                console.error(res);
            }
        };
        return fetchData();
    }, []);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    const handleExpand = (name, value) => {
        setExpand((st) => ({ ...st, [name]: value }));
    };

    const handleFilter = (value, key) => {
        let searchValue = value.toLowerCase();

        let { tCardStatus = [], recall = [] } = filterTcard;

        const filterByKey = (data) => data.filter((item) => item[key]?.toLowerCase().includes(searchValue));

        setTCardList((prev) => ({
            ...prev,
            tCardStatus: filterByKey(tCardStatus),
            recall: filterByKey(recall)
        }));
    };

    const handleChange = (e) => {
        const branchID = e.target.value;
        const tempObj = branchList.find((k) => k.id == branchID);

        if (tempObj) {
            const branchName = tempObj.name;

            const tempData = {
                ...JSON.parse(localStorage.getItem('_dashboard_') || '{}'),
                BranchBytime: branchName,
                selectedValueByTech: branchName,
                BranchPartReq: branchName,
                branchShortName: branchName
            };
            localStorage.setItem('_dashboard_', JSON.stringify(tempData));

            const btTimeData = {
                ...JSON.parse(localStorage.getItem('FiltterParams') || '{}'),
                branchShortName: branchName
            };
            localStorage.setItem('FiltterParams', JSON.stringify(btTimeData));
        }

        // Always run state updates
        // setLoader(true);
        setTCardList((prev) => ({
            ...prev,
            branchID
        }));
    };

    const handleDragEnd = async (result) => {
        try {
            const { source, destination, draggableId } = result;

            if (!destination) return;

            if (source.droppableId === destination.droppableId && source.index === destination.index) {
                console.log('Item dropped in the same position. No action taken.');
                return;
            }

            const newState = {
                ...tCardList,
                recall: [...tCardList.recall],
                tCardStatus: [...tCardList.tCardStatus]
            };

            let draggedItem = null;
            let sourceArray = '';

            if (source.droppableId === 'recall') {
                draggedItem = newState.recall.find((item) => item.tCardsID.toString() === draggableId);
                sourceArray = 'recall';
            } else if (source.droppableId === 'ToBeSchWithoutDate') {
                draggedItem = newState.tCardStatus.find((item) => item.tCardsID.toString() === draggableId && item.status === 'TO BE SCHEDULED');
                sourceArray = 'tCardStatus';
            } else {
                draggedItem = newState.tCardStatus.find((item) => item.tCardsID.toString() === draggableId && item.status === source.droppableId);
                sourceArray = 'tCardStatus';
            }

            if (!draggedItem) {
                console.error(`Dragged item with ID ${draggableId} not found in source: ${source.droppableId}`);
                return;
            }

            // Remove from source
            if (sourceArray === 'recall') {
                newState.recall = newState.recall.filter((item) => item.tCardsID.toString() !== draggableId);
            } else {
                newState.tCardStatus = newState.tCardStatus.filter((item) => !(item.tCardsID.toString() === draggableId && item.status === source.droppableId));
            }

            // Update item status
            if (destination.droppableId !== 'recall') {
                draggedItem = {
                    ...draggedItem,
                    status: destination.droppableId
                };
            }

            // Add to destination
            if (destination.droppableId === 'recall') {
                newState.recall.push(draggedItem);
            } else {
                newState.tCardStatus.push(draggedItem);
            }

            // Update UI optimistically
            setTCardList(newState);

            // Map destination to status
            const statusArray = JSON.parse(statusObject);
            const targetStatus = destination.droppableId === 'recall' ? 'BOOKING CONFIRMED' : destination.droppableId;
            const StatusID = statusArray.find((k) => k.status === targetStatus);

            if (!StatusID) {
                console.error(`Status not found for ${targetStatus}`);
                return;
            }

            const payload = {
                tCardsStatusID: StatusID.id,
                tCardsID: +draggableId
            };

            const res = await postTCardsDragStatus(payload);

            if (res.success) {
                setLoader(true);
                fetchData();
                showToast(`T-card moved from ${source.droppableId} to ${destination.droppableId} successfully`);
            } else {
                showToast(`Failed to move T-card from ${source.droppableId} to ${destination.droppableId}`);
            }
        } catch (error) {
            console.error('Error during handleDragEnd:', error);
            showToast('Unexpected error occurred while processing drag-and-drop');
        }
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                const res = await getTcardBranchData();
                if (res?.success && Array.isArray(res.data?.branches)) {
                    const branches = res.data.branches;
                    setBranchList(branches);

                    const dashboardData = JSON.parse(localStorage.getItem('_dashboard_') || '{}');
                    const selectedBranchName = dashboardData.BranchPartReq;

                    const matchedBranch = branches.find((b) => b.name === selectedBranchName);
                    const fallbackBranchID = branches[0]?.id || null;

                    setTCardList((prev) => ({
                        ...prev,
                        branchID: matchedBranch?.id || fallbackBranchID
                    }));
                } else {
                    console.error('Failed to fetch branches or no branches returned');
                }
            } catch (error) {
                console.error('Error fetching TCard branch data:', error);
            }
        };

        fetchData();
    }, []);

    const handleCustomerFilter = (e) => {
        let { value } = e.target;

        setFilters((st) => ({ ...st, cust: value }));
        handleFilter(value, 'cust');
    };

    const handleRegNoFilter = (e) => {
        let { value } = e.target;

        handleFilter(value, 'reg');
        setFilters((st) => ({ ...st, regNo: value }));
    };

    function getWeekNumber(dateStr) {
        if (!dateStr) return 'No Date';

        const date = new Date(dateStr);
        if (isNaN(date.getTime())) return 'Invalid Date';

        const tempDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
        const dayNum = tempDate.getUTCDay() || 7;
        tempDate.setUTCDate(tempDate.getUTCDate() + 4 - dayNum);
        const yearStart = new Date(Date.UTC(tempDate.getUTCFullYear(), 0, 1));
        const weekNo = Math.ceil(((tempDate - yearStart) / 86400000 + 1) / 7);
        return `Week ${weekNo} `;
    }

    const toBeScheduledCards = (data) => {
        // console.log(data, 'toBeScheduledCards');
        const list = data.filter((item) => item.status === 'TO BE SCHEDULED' && item.dd);

        const groupedByWeek = list.reduce((acc, card) => {
            const week = getWeekNumber(card.dd);
            if (!acc[week]) acc[week] = [];
            acc[week].push(card);
            return acc;
        }, {});
        // return groupedByWeek;
        return Object.entries(groupedByWeek || {});
    };

    return (
        <div style={{ padding: '10px  ' }}>
            <TableContainer component={Paper} style={{ height: 'calc(100vh - 125px)' }}>
                {loader ? (
                    <div style={{ marginTop: 30 }}>
                        <CircularProgress />
                    </div>
                ) : (
                    <Table className={classes.table} aria-label="simple table" stickyHeader>
                        <TableHead>
                            <TableRow>
                                <StyledTableCell align="center" colSpan={4}>
                                    <Grid container spacing={1}>
                                        {legendItems.map((item, index) => (
                                            <Grid item key={index}>
                                                <div
                                                    style={{
                                                        fontSize: 10,
                                                        fontWeight: 800,
                                                        background: item.background,
                                                        color: item.color,
                                                        padding: '1px 6px',
                                                        // borderRadius: '4px',
                                                        textAlign: 'center',
                                                        minWidth: '40px',
                                                        marginLeft: 10
                                                    }}
                                                >
                                                    {item.label}
                                                </div>
                                            </Grid>
                                        ))}
                                    </Grid>
                                </StyledTableCell>

                                <StyledTableCell align="center" colSpan={4}>
                                    <Grid container spacing={2} justifyContent="flex-end" alignItems="center">
                                        <Grid item>
                                            <input onChange={handleCustomerFilter} placeholder="Search customer" value={filters.cust} name="cust" />
                                        </Grid>
                                        <Grid item>
                                            <input onChange={handleRegNoFilter} placeholder="Search Reg No." value={filters.regNo} name="regNo" />
                                        </Grid>
                                        <Grid item>
                                            {' '}
                                            <div
                                                onClick={() => history.push('/CheckInDashboard')}
                                                style={{ color: 'white', fontSize: 11, background: 'green', padding: '0px 8px', cursor: 'pointer' }}
                                                size="small"
                                            >
                                                Create T-Card
                                            </div>
                                        </Grid>

                                        <Grid item>
                                            {' '}
                                            <select onChange={handleChange} value={tCardList.branchID}>
                                                {branchList.map((btn, i) => {
                                                    return (
                                                        <option key={i} value={btn.id}>
                                                            {btn.name}{' '}
                                                        </option>
                                                    );
                                                })}
                                            </select>
                                        </Grid>
                                    </Grid>
                                </StyledTableCell>
                            </TableRow>
                        </TableHead>
                        <DragDropContext onDragEnd={handleDragEnd}>
                            <TableBody>
                                <TableRow>
                                    {/* Recall Column */}
                                    <StyledTableCell align="center" width={'12.5%'}>
                                        <div style={{ background: 'lightgrey' }}>
                                            <Typography
                                                style={{
                                                    textAlign: 'center',
                                                    fontWeight: 700,
                                                    textTransform: 'uppercase',
                                                    fontSize: 12
                                                }}
                                            >
                                                Recall <small>({tCardList.recall.length})</small>
                                            </Typography>
                                        </div>
                                        <div className={`${classes.colHeight} custom-scroll`} style={marginBottom}>
                                            {tCardList.tpNames.map((tpName, tpIndex) => (
                                                <div key={tpName}>
                                                    <Typography
                                                        style={{
                                                            paddingLeft: 5,
                                                            textAlign: 'center',
                                                            fontWeight: 700,
                                                            textTransform: 'uppercase',
                                                            fontSize: 10,
                                                            backgroundColor: 'skyblue'
                                                        }}
                                                    >
                                                        {tpName}
                                                    </Typography>

                                                    <Droppable droppableId={'RECALL'} direction="vertical">
                                                        {(provided, snapshot) => {
                                                            const items = tCardList.recall.filter((m) => m.tp === tpName);

                                                            return (
                                                                <div ref={provided.innerRef} {...provided.droppableProps}>
                                                                    {items.length === 0 && !snapshot.isDraggingOver && (
                                                                        <div className={classes.noRecordFound}>No Record Found</div>
                                                                    )}

                                                                    <div></div>

                                                                    {items.map((k, index) => (
                                                                        <Draggable
                                                                            key={k.tCardsID}
                                                                            // isDragDisabled={checkIsTcardReadonly}
                                                                            draggableId={k.tCardsID.toString()}
                                                                            index={index}
                                                                        >
                                                                            {(provided) => (
                                                                                <div
                                                                                    ref={provided.innerRef}
                                                                                    {...provided.draggableProps}
                                                                                    {...provided.dragHandleProps}
                                                                                    style={{
                                                                                        // marginBottom: 8,
                                                                                        ...provided.draggableProps.style
                                                                                    }}
                                                                                >
                                                                                    <Tcard
                                                                                        legendItems={legendItems}
                                                                                        handleTcardOpen={handleTcardOpen}
                                                                                        date={k.bd}
                                                                                        days={k.days}
                                                                                        customer={k.cust}
                                                                                        isLoanVehicle={k.loanVehicle}
                                                                                        registration={k.reg}
                                                                                        textColor={k.tc}
                                                                                        color={k.bgc}
                                                                                        tCardsID={k.tCardsID}
                                                                                        wn={k.wn}
                                                                                        vsc={k.vsc}
                                                                                        breakdown={k.breakdown}
                                                                                        breakdownStatus={k.breakdownStatus}
                                                                                        breakdownTime={k.breakdownTime}
                                                                                        status={{
                                                                                            recall: k.recall,
                                                                                            tacho: k.tacho,
                                                                                            mot: k.mot,
                                                                                            repair: k.repair,
                                                                                            inspection: k.inspection,
                                                                                            cd: k.cd,
                                                                                            waiting: k.waiting,
                                                                                            service: k.service,
                                                                                            ns: k.ns
                                                                                        }}
                                                                                    />
                                                                                </div>
                                                                            )}
                                                                        </Draggable>
                                                                    ))}

                                                                    {snapshot.isDraggingOver && items.length > 0 && (
                                                                        <div className={classes.noRecordFound}>Drop Here</div>
                                                                    )}
                                                                    {provided.placeholder}
                                                                </div>
                                                            );
                                                        }}
                                                    </Droppable>
                                                </div>
                                            ))}
                                        </div>
                                    </StyledTableCell>

                                    {/* Status Columns */}
                                    {statusSeq.map((k, i) => {
                                        let getName = status.find((m) => m.id === k);
                                        let statusName = getName ? getName.name : '';

                                        console.log(getName, 'getName');
                                        console.log(statusName, 'statusName');
                                        if (statusName) {
                                            return (
                                                <StyledTableCell align="center" width={'12.5%'} key={i} rowSpan={3}>
                                                    <div style={{ background: 'lightgrey' }}>
                                                        <Typography
                                                            style={{
                                                                textAlign: 'center',
                                                                fontWeight: 700,
                                                                textTransform: 'uppercase',
                                                                fontSize: 12
                                                            }}
                                                        >
                                                            {statusName}
                                                        </Typography>
                                                    </div>
                                                    <Droppable droppableId={statusName} direction="vertical">
                                                        {(provided, snapshot) => {
                                                            const cardsForStatus = tCardList.tCardStatus.filter((m) => m.status === statusName);

                                                            return (
                                                                <div
                                                                    ref={provided.innerRef}
                                                                    {...provided.droppableProps}
                                                                    className={`${classes.colHeight} custom-scroll`}
                                                                    style={{
                                                                        minHeight: '400px',
                                                                        overflowY: 'auto',
                                                                        position: 'relative'
                                                                    }}
                                                                >
                                                                    {cardsForStatus.length === 0 ? (
                                                                        <div className={classes.noRecordFound}>
                                                                            <span>{snapshot.isDraggingOver ? 'Drop Here' : 'No Record Found'}</span>
                                                                        </div>
                                                                    ) : (
                                                                        cardsForStatus.map((k, index) => (
                                                                            <Draggable
                                                                                key={k.tCardsID}
                                                                                draggableId={k.tCardsID.toString()}
                                                                                obj={k}
                                                                                index={index}
                                                                            >
                                                                                {(provided) => (
                                                                                    <div
                                                                                        ref={provided.innerRef}
                                                                                        {...provided.draggableProps}
                                                                                        {...provided.dragHandleProps}
                                                                                        style={{
                                                                                            ...provided.draggableProps.style
                                                                                        }}
                                                                                    >
                                                                                        <Tcard
                                                                                            legendItems={legendItems}
                                                                                            handleTcardOpen={handleTcardOpen}
                                                                                            date={k.bd}
                                                                                            days={k.days}
                                                                                            customer={k.cust}
                                                                                            isLoanVehicle={k.loanVehicle}
                                                                                            registration={k.reg}
                                                                                            textColor={k.tc}
                                                                                            color={k.bgc}
                                                                                            tCardsID={k.tCardsID}
                                                                                            wn={k.wn}
                                                                                            vsc={k.vsc}
                                                                                            breakdown={k.breakdown}
                                                                                            breakdownStatus={k.breakdownStatus}
                                                                                            breakdownTime={k.breakdownTime}
                                                                                            status={{
                                                                                                recall: k.recall,
                                                                                                tacho: k.tacho,
                                                                                                mot: k.mot,
                                                                                                repair: k.repair,
                                                                                                inspection: k.inspection,
                                                                                                cd: k.cd,
                                                                                                waiting: k.waiting,
                                                                                                service: k.service,
                                                                                                ns: k.ns
                                                                                            }}
                                                                                        />
                                                                                    </div>
                                                                                )}
                                                                            </Draggable>
                                                                        ))
                                                                    )}
                                                                    {snapshot.isDraggingOver && cardsForStatus.length > 0 && (
                                                                        <div className={classes.noRecordFound}>
                                                                            <span>{'Drop Here'}</span>
                                                                        </div>
                                                                    )}
                                                                    {provided.placeholder}
                                                                </div>
                                                            );
                                                        }}
                                                    </Droppable>
                                                </StyledTableCell>
                                            );
                                        }
                                    })}
                                </TableRow>
                                {statusSeq2.map((k, i) => {
                                    let getName = status.find((m) => m.id === k);
                                    let statusName = getName ? getName.name : '';
                                    let dataList = toBeScheduledCards(tCardList?.tCardStatus);
                                    // console.log(dataList, 'dataList');
                                    if (getName) {
                                        if (k !== 0) {
                                            return (
                                                <TableRow key={i}>
                                                    <StyledTableCell align="center" width={'12.5%'}>
                                                        <div style={{ background: 'lightgrey' }}>
                                                            <Typography
                                                                style={{
                                                                    textAlign: 'center',
                                                                    fontWeight: 700,
                                                                    textTransform: 'uppercase',
                                                                    fontSize: 12
                                                                }}
                                                            >
                                                                {statusName}
                                                            </Typography>
                                                        </div>

                                                        <Droppable droppableId={statusName} direction="vertical">
                                                            {(provided, snapshot) => {
                                                                const cards = tCardList.tCardStatus.filter((m) => m.status === statusName);

                                                                return (
                                                                    <div
                                                                        ref={provided.innerRef}
                                                                        {...provided.droppableProps}
                                                                        className={`${classes.colHeight} custom-scroll`}
                                                                    >
                                                                        {cards.length === 0 ? (
                                                                            <div className={classes.noRecordFound}>
                                                                                <span>{snapshot.isDraggingOver ? 'Drop Here' : 'No Record Found'}</span>
                                                                            </div>
                                                                        ) : (
                                                                            cards.map((k, index) => (
                                                                                <Draggable
                                                                                    key={k.tCardsID}
                                                                                    draggableId={k.tCardsID.toString()}
                                                                                    obj={k}
                                                                                    index={index}
                                                                                >
                                                                                    {(provided) => (
                                                                                        <div
                                                                                            ref={provided.innerRef}
                                                                                            {...provided.draggableProps}
                                                                                            {...provided.dragHandleProps}
                                                                                            style={{
                                                                                                ...provided.draggableProps.style
                                                                                            }}
                                                                                        >
                                                                                            <Tcard
                                                                                                legendItems={legendItems}
                                                                                                handleTcardOpen={handleTcardOpen}
                                                                                                date={k.bd}
                                                                                                days={k.days}
                                                                                                customer={k.cust}
                                                                                                isLoanVehicle={k.loanVehicle}
                                                                                                registration={k.reg}
                                                                                                textColor={k.tc}
                                                                                                color={k.bgc}
                                                                                                tCardsID={k.tCardsID}
                                                                                                wn={k.wn}
                                                                                                vsc={k.vsc}
                                                                                                breakdown={k.breakdown}
                                                                                                breakdownStatus={k.breakdownStatus}
                                                                                                breakdownTime={k.breakdownTime}
                                                                                                status={{
                                                                                                    recall: k.recall,
                                                                                                    tacho: k.tacho,
                                                                                                    mot: k.mot,
                                                                                                    repair: k.repair,
                                                                                                    inspection: k.inspection,
                                                                                                    cd: k.cd,
                                                                                                    waiting: k.waiting,
                                                                                                    service: k.service,
                                                                                                    ns: k.ns
                                                                                                }}
                                                                                            />
                                                                                        </div>
                                                                                    )}
                                                                                </Draggable>
                                                                            ))
                                                                        )}
                                                                        {snapshot.isDraggingOver && cards.length > 0 && (
                                                                            <div className={classes.noRecordFound}>
                                                                                <span>{'Drop Here'}</span>
                                                                            </div>
                                                                        )}
                                                                        {provided.placeholder}
                                                                    </div>
                                                                );
                                                            }}
                                                        </Droppable>
                                                    </StyledTableCell>
                                                </TableRow>
                                            );
                                        } else {
                                            return (
                                                <TableRow>
                                                    <StyledTableCell align="center" width={'12.5%'}>
                                                        <div style={{ background: 'lightgrey' }}>
                                                            <Typography
                                                                style={{ textAlign: 'center', fontWeight: 700, textTransform: 'uppercase', fontSize: 12 }}
                                                            >
                                                                {statusName}
                                                            </Typography>
                                                        </div>{' '}
                                                        <Droppable droppableId="TO BE SCHEDULED" direction="vertical" obj={k}>
                                                            {(provided, snapshot) => (
                                                                <>
                                                                    <div
                                                                        ref={provided.innerRef}
                                                                        {...provided.droppableProps}
                                                                        className={`${classes.colHeight} custom-scroll`}
                                                                    >
                                                                        {dataList.length === 0 ? (
                                                                            <div className={classes.noRecordFound}>
                                                                                <span>{snapshot.isDraggingOver ? 'Drop Here' : 'No Record Found'}</span>
                                                                            </div>
                                                                        ) : (
                                                                            dataList
                                                                                .sort(([weekA], [weekB]) => {
                                                                                    const numA = parseInt(weekA.replace(/\D/g, ''), 10);
                                                                                    const numB = parseInt(weekB.replace(/\D/g, ''), 10);
                                                                                    return numA - numB;
                                                                                })
                                                                                .map(([week, cards]) => (
                                                                                    <div
                                                                                        key={week}
                                                                                        style={{
                                                                                            background: portalSetting.portalSettingsIsHolidayColor
                                                                                        }}
                                                                                    >
                                                                                        <Typography
                                                                                            style={{
                                                                                                fontWeight: 600,
                                                                                                fontSize: 12,
                                                                                                background:
                                                                                                    portalSetting.portalSettingsIsHolidayBgColor || '#F88379',
                                                                                                color: portalSetting.portalSettingsIsHolidayColor,
                                                                                                display: 'flex',
                                                                                                alignItems: 'center',
                                                                                                justifyContent: 'space-between',
                                                                                                padding: '0 5px'
                                                                                            }}
                                                                                        >
                                                                                            <span>
                                                                                                {week} - {cards.length}
                                                                                            </span>
                                                                                            <span>
                                                                                                {!expand[week] ? (
                                                                                                    <ExpandMoreIcon
                                                                                                        onClick={() => handleExpand(week, true)}
                                                                                                        style={{
                                                                                                            fontSize: 12,
                                                                                                            marginRight: 5,
                                                                                                            marginTop: 1,
                                                                                                            cursor: 'pointer'
                                                                                                        }}
                                                                                                    />
                                                                                                ) : (
                                                                                                    <ExpandLessIcon
                                                                                                        onClick={() => handleExpand(week, false)}
                                                                                                        style={{
                                                                                                            fontSize: 12,
                                                                                                            marginRight: 5,
                                                                                                            marginTop: 1,
                                                                                                            cursor: 'pointer'
                                                                                                        }}
                                                                                                    />
                                                                                                )}
                                                                                            </span>
                                                                                        </Typography>

                                                                                        {expand[week] &&
                                                                                            cards.map((k, index) => (
                                                                                                <Draggable
                                                                                                    key={k.tCardsID}
                                                                                                    draggableId={k.tCardsID.toString()}
                                                                                                    index={index}
                                                                                                    obj={k}
                                                                                                >
                                                                                                    {(provided) => (
                                                                                                        <div
                                                                                                            ref={provided.innerRef}
                                                                                                            {...provided.draggableProps}
                                                                                                            {...provided.dragHandleProps}
                                                                                                        >
                                                                                                            <Tcard
                                                                                                                legendItems={legendItems}
                                                                                                                handleTcardOpen={handleTcardOpen}
                                                                                                                date={k.bd}
                                                                                                                days={k.days}
                                                                                                                customer={k.cust}
                                                                                                                isLoanVehicle={k.loanVehicle}
                                                                                                                registration={k.reg}
                                                                                                                textColor={k.tc}
                                                                                                                color={k.bgc}
                                                                                                                tCardsID={k.tCardsID}
                                                                                                                wn={k.wn}
                                                                                                                vsc={k.vsc}
                                                                                                                breakdown={k.breakdown}
                                                                                                                breakdownStatus={k.breakdownStatus}
                                                                                                                breakdownTime={k.breakdownTime}
                                                                                                                status={{
                                                                                                                    recall: k.recall,
                                                                                                                    tacho: k.tacho,
                                                                                                                    mot: k.mot,
                                                                                                                    repair: k.repair,
                                                                                                                    inspection: k.inspection,
                                                                                                                    cd: k.cd,
                                                                                                                    waiting: k.waiting,
                                                                                                                    service: k.service,
                                                                                                                    ns: k.ns
                                                                                                                }}
                                                                                                            />
                                                                                                        </div>
                                                                                                    )}
                                                                                                </Draggable>
                                                                                            ))}
                                                                                    </div>
                                                                                ))
                                                                        )}
                                                                        {provided.placeholder}
                                                                    </div>
                                                                    <div>
                                                                        {tCardList?.tCardStatus
                                                                            ?.filter((m) => m.status === 'TO BE SCHEDULED' && !m.dd)
                                                                            .map((k, index) => (
                                                                                <>
                                                                                    {index === 0 && (
                                                                                        <Typography
                                                                                            style={{
                                                                                                fontWeight: 600,
                                                                                                fontSize: 12,
                                                                                                background:
                                                                                                    portalSetting.portalSettingsIsHolidayBgColor || '#F88379',
                                                                                                color: portalSetting.portalSettingsIsHolidayColor,
                                                                                                display: 'flex',
                                                                                                alignItems: 'center',
                                                                                                justifyContent: 'space-between',
                                                                                                padding: '0 5px'
                                                                                            }}
                                                                                        >
                                                                                            <span>Date not set</span>
                                                                                            <span>
                                                                                                {!expand['notSet'] ? (
                                                                                                    <ExpandMoreIcon
                                                                                                        onClick={() => handleExpand('notSet', true)}
                                                                                                        style={{
                                                                                                            fontSize: 12,
                                                                                                            marginRight: 5,
                                                                                                            marginTop: 1,
                                                                                                            cursor: 'pointer'
                                                                                                        }}
                                                                                                    />
                                                                                                ) : (
                                                                                                    <ExpandLessIcon
                                                                                                        onClick={() => handleExpand('notSet', false)}
                                                                                                        style={{
                                                                                                            fontSize: 12,
                                                                                                            marginRight: 5,
                                                                                                            marginTop: 1,
                                                                                                            cursor: 'pointer'
                                                                                                        }}
                                                                                                    />
                                                                                                )}
                                                                                            </span>
                                                                                        </Typography>
                                                                                    )}
                                                                                    {expand['notSet'] && (
                                                                                        <Draggable
                                                                                            key={k.tCardsID}
                                                                                            draggableId={k.tCardsID.toString()}
                                                                                            index={index}
                                                                                            obj={k}
                                                                                        >
                                                                                            {(provided) => (
                                                                                                <div
                                                                                                    ref={provided.innerRef}
                                                                                                    {...provided.draggableProps}
                                                                                                    {...provided.dragHandleProps}
                                                                                                >
                                                                                                    <Tcard
                                                                                                        legendItems={legendItems}
                                                                                                        handleTcardOpen={handleTcardOpen}
                                                                                                        date={k.bd}
                                                                                                        days={k.days}
                                                                                                        customer={k.cust}
                                                                                                        isLoanVehicle={k.loanVehicle}
                                                                                                        registration={k.reg}
                                                                                                        textColor={k.tc}
                                                                                                        color={k.bgc}
                                                                                                        tCardsID={k.tCardsID}
                                                                                                        wn={k.wn}
                                                                                                        vsc={k.vsc}
                                                                                                        breakdown={k.breakdown}
                                                                                                        breakdownStatus={k.breakdownStatus}
                                                                                                        breakdownTime={k.breakdownTime}
                                                                                                        status={{
                                                                                                            recall: k.recall,
                                                                                                            tacho: k.tacho,
                                                                                                            mot: k.mot,
                                                                                                            repair: k.repair,
                                                                                                            inspection: k.inspection,
                                                                                                            cd: k.cd,
                                                                                                            waiting: k.waiting,
                                                                                                            service: k.service,
                                                                                                            ns: k.ns
                                                                                                        }}
                                                                                                    />
                                                                                                </div>
                                                                                            )}
                                                                                        </Draggable>
                                                                                    )}
                                                                                </>
                                                                            ))}
                                                                        {/* {dataList.length > 0 && snapshot.isDraggingOver && (
                                                                        <div className={classes.noRecordFound}>
                                                                            <span>{'Drop Here'}</span>
                                                                        </div>
                                                                    )} */}
                                                                        {provided.placeholder}
                                                                    </div>
                                                                </>
                                                            )}
                                                        </Droppable>
                                                    </StyledTableCell>
                                                </TableRow>
                                            );
                                        }
                                    }
                                })}
                            </TableBody>
                        </DragDropContext>
                    </Table>
                )}
            </TableContainer>

            {openModal ? <TCardDashboardModal id={tCardList.tCardID} onClose={handleTcardOpen} tCardSelectedColor={tCardList?.tCardSelectedColor} /> : null}
        </div>
    );
};

export default InProgress;
